import { ControlWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';

@Component({
  selector: 'app-sf-input-widget',
  templateUrl: './input.widget.html'
})
export class MyInputWidgetComponent extends ControlWidget {

}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/input/input.widget.ts